(ns vit-configurator.subs
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]))

(defn get-or-nil
  [kw]
  (fn [db _] (get db kw nil)))

(re-frame/reg-sub ::auth-required? (get-or-nil :auth-required?))
(re-frame/reg-sub ::authenticated? (get-or-nil :authenticated?))
(re-frame/reg-sub ::auth-loading? (get-or-nil :auth-loading?))
(re-frame/reg-sub ::user (get-or-nil :user))
(re-frame/reg-sub ::user-loading? (get-or-nil :user-loading?))
(re-frame/reg-sub ::title (get-or-nil :title))
(re-frame/reg-sub ::embedded-line1 (get-or-nil :embedded-line1))
(re-frame/reg-sub ::embedded-line1-hidden (get-or-nil :embedded-line1-hidden))
(re-frame/reg-sub ::embedded-line2 (get-or-nil :embedded-line2))
(re-frame/reg-sub ::embedded-line2-hidden (get-or-nil :embedded-line2-hidden))
(re-frame/reg-sub ::embedded-line3 (get-or-nil :embedded-line3))
(re-frame/reg-sub ::embedded-line3-hidden (get-or-nil :embedded-line3-hidden))
(re-frame/reg-sub ::voter-info (get-or-nil :voter-info))
(re-frame/reg-sub ::logo (get-or-nil :logo))
(re-frame/reg-sub ::language (get-or-nil :language))
(re-frame/reg-sub ::official-only (get-or-nil :official-only))
(re-frame/reg-sub ::links (get-or-nil :links))
(re-frame/reg-sub ::summary-top-txt (get-or-nil :summary-top-txt))
(re-frame/reg-sub ::summary-bottom-txt (get-or-nil :summary-bottom-txt))
(re-frame/reg-sub ::summary-vote-by-mail-txt (get-or-nil :summary-vote-by-mail-txt))
(re-frame/reg-sub ::summary-absentee-hidden (get-or-nil :summary-absentee-hidden))
(re-frame/reg-sub ::size (get-or-nil :size))
(re-frame/reg-sub ::search-box-type (get-or-nil :search-box-type))
(re-frame/reg-sub ::analytics (get-or-nil :analytics))
(re-frame/reg-sub ::analytics-custom (get-or-nil :analytics-custom))
(re-frame/reg-sub ::vit-preview-env (get-or-nil :vit-preview-env))

(re-frame/reg-sub ::clj-config :config)

(defn js-config
  [db _]
  (-> (:config db)
      clj->js
      (.stringify js/JSON)))
(re-frame/reg-sub ::js-config js-config)
